<template>
    <div class="field_head " :class="{'cursor-pointer' : this.can_sort}" v-on:click="setListOrdering">
        {{this.field_name}}

        <div class="badge badge-info" v-if="is_current_field_sort">
            <i :class="current_sort_class" class="fal opacity-100 color-white"></i>
        </div>

    </div>

</template>

<script>

    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'inbox_state/getInboxStateField',
        mutationType: 'inbox_state/updateInboxStateField',
    });

    export default {
        name: "grid_id",

        props: {

            can_sort : {
                type : Boolean,
                default : true,
            },

            list_ordering : {
                type : String,
                required:true
            },


            field_name : {
                type : String,
                required:true
            },

            head_item : {
                type: Object
            }

        },


        methods: {
           async  setListOrdering() {

               //force 1 page
               this.send_list.limit_start = 0;
               this.send_list.direction = this.set_sort_direction;
               this.send_list.ordering = this.list_ordering;

               EventBus.$emit("inbox_change_state",{
                   "type" : "SortingFiledCalled",
               })
           }
        },

        computed: {

            ...mapFields([
                'list',
                'doc_type',
                'send_list'
            ]),

            current_sort_item () {
                return this.list.ordering;
            },

            current_sort_direction () {
                return this.list.direction.toUpperCase();
            },

            set_sort_direction() {
                if(this.current_sort_direction.toUpperCase() == "DESC" ) {
                    if(this.is_current_field_sort) {
                        return "ASC";
                    }
                    else {
                        return "DESC";
                    }
                }
                return "DESC";
            },

            current_sort_class() {
                if(this.is_current_field_sort) {
                    if (this.current_sort_direction.toUpperCase() == "DESC") {
                        return "fa-arrow-alt-to-bottom";
                    }
                    return "fa-arrow-alt-to-top";
                }

                return "";
            },

            is_current_field_sort() {
                return this.current_sort_item === this.list_ordering;
            },
        }
    }
</script>

<style scoped>

</style>
